import createIcon from '../../createIcon';

/**
 * @component @name Tenmp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNSA3SDE1VjEwSDEzLjVWN1pNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xMiAxOC41SDEwLjVWMTRIOS41VjE3SDhWMTRIN1YxOC41SDUuNVYxMy41QzUuNSAxMi45NSA1Ljk1IDEyLjUgNi41IDEyLjVIMTFDMTEuNTUgMTIuNSAxMiAxMi45NSAxMiAxMy41VjE4LjVaTTE1LjUgMTguNUgxNFYxMi41SDE3LjVDMTguMDUgMTIuNSAxOC41IDEyLjk1IDE4LjUgMTMuNVYxNkMxOC41IDE2LjU1IDE4LjA1IDE3IDE3LjUgMTdIMTUuNVYxOC41Wk0xMCA1LjVWMTEuNUg4LjVWN0g3VjUuNUgxMFpNMTYuNSAxMC41QzE2LjUgMTEuMDUgMTYuMDUgMTEuNSAxNS41IDExLjVIMTNDMTIuNDUgMTEuNSAxMiAxMS4wNSAxMiAxMC41VjYuNUMxMiA1Ljk1IDEyLjQ1IDUuNSAxMyA1LjVIMTUuNUMxNi4wNSA1LjUgMTYuNSA1Ljk1IDE2LjUgNi41VjEwLjVaTTE1LjUgMTRIMTdWMTUuNUgxNS41VjE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Tenmp = createIcon('Tenmp', [
  [
    'path',
    {
      d: 'M13.5 7H15V10H13.5V7ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 18.5H10.5V14H9.5V17H8V14H7V18.5H5.5V13.5C5.5 12.95 5.95 12.5 6.5 12.5H11C11.55 12.5 12 12.95 12 13.5V18.5ZM15.5 18.5H14V12.5H17.5C18.05 12.5 18.5 12.95 18.5 13.5V16C18.5 16.55 18.05 17 17.5 17H15.5V18.5ZM10 5.5V11.5H8.5V7H7V5.5H10ZM16.5 10.5C16.5 11.05 16.05 11.5 15.5 11.5H13C12.45 11.5 12 11.05 12 10.5V6.5C12 5.95 12.45 5.5 13 5.5H15.5C16.05 5.5 16.5 5.95 16.5 6.5V10.5ZM15.5 14H17V15.5H15.5V14Z',
      key: 'quvtm5',
    },
  ],
]);

export default Tenmp;
